import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../../../../../CommonUtils/formatNumber';
import { useEstatePlanningFlowQuery } from '../../api/useEstatePlanningFlowQuery';
import { UserType } from '../../EstatePlanningFlow.meta';
import { AdditionalInfo } from '../AdditionalInfo/AdditionalInfo';

interface Props {
  userType: UserType;
}

export const Stats = ({ userType }: Props) => {
  const { data, isLoading } = useEstatePlanningFlowQuery({
    isSpouse: userType === UserType.Partner,
  });

  if (isLoading || !data) {
    return null;
  }

  const {
    stats: { adjustedGrossEstate, grossEstate, taxableEstate },
  } = data;

  return (
    <Box my="24">
      <Card hasBorder>
        <Box display="flex">
          <Box px="24" py="8" display="flex" flexDirection="column" flex={1}>
            <Text mb="4" variant="smallCaps">
              Gross Estate
              <AdditionalInfo additionalInfo={grossEstate.additionalInfo} />
            </Text>

            <Text variant="tabular" fontSize="h4" fontWeight={500}>
              {formatCurrency(grossEstate.value)}
            </Text>
          </Box>

          <Box
            px="24"
            py="8"
            display="flex"
            flexDirection="column"
            flex={1}
            borderLeft="1px solid"
            borderRight="1px solid"
            borderColor="neutral.200"
          >
            <Text mb="4" variant="smallCaps">
              Adjusted gross Estate
              <AdditionalInfo additionalInfo={adjustedGrossEstate.additionalInfo} />
            </Text>

            <Text variant="tabular" fontSize="h4" fontWeight={500}>
              {formatCurrency(adjustedGrossEstate.value)}
            </Text>
          </Box>

          <Box px="24" py="8" display="flex" flexDirection="column" flex={1}>
            <Text mb="4" variant="smallCaps">
              Taxable Estate
              <AdditionalInfo additionalInfo={taxableEstate.additionalInfo} />
            </Text>

            <Text variant="tabular" fontSize="h4" fontWeight={500}>
              {formatCurrency(taxableEstate.value)}
            </Text>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
